module.exports = __webpack_public_path__ + "media/music-video.24bc94cd.mp4";